// import './Experts.css'


// const Experts = () => {        
//     return (        
//         <>
//             <div className="oracle-expert-banner">
//                 <img src={process.env.PUBLIC_URL + "/images/salesforce/Expertbanner.png"} alt="Expert Banner" />
//             </div>
//             <div className="oracle-expert-content">
//                 <p>
//                 Meet the minds behind ATCI’s intensive, innovative, fit-for-market Saleforce learning programs, enabling Accenture to lead in the marketplace and deliver on the promise of client excellence.
//                 </p>
//             </div>
//             <div className="experts_container">            
//                 <img src="/images/salesforce/Experts/praveen_rajaram.png" alt="Expert" className="saleForce_expert" />
//                 <img src="/images/salesforce/Experts/s_saraswathi.png" alt="Expert" className="saleForce_expert" />
//                 <img src="/images/salesforce/Experts/Suresh HN.png" alt="Expert" className="saleForce_expert" />
//                 <img src="/images/salesforce/Experts/Krishna Kishore.png" alt="Expert" className="saleForce_expert" />
//                 <img src="/images/salesforce/Experts/Simhadri Pv.png" alt="Expert" className="saleForce_expert" />
//                 <img src="/images/salesforce/Experts/Shaik Shaikshavali.png" alt="Expert" className="saleForce_expert" />                                                                
//                 <img src="/images/salesforce/Experts/Monish Aditya.png" alt="Expert" className="saleForce_expert" />
//                 <img src="/images/salesforce/Experts/Sruthi Tatapudi.png" alt="Expert" className="saleForce_expert" />
//                 <img src="/images/salesforce/Experts/srividya_murali.png" alt="Expert" className="saleForce_expert" />
//                 <img src="/images/salesforce/Experts/pooja_kudale.png" alt="Expert" className="saleForce_expert" />                                                                  
//                 <img src="/images/salesforce/Experts/mrunal_khandagale.png" alt="Expert" className="saleForce_expert" />               
//                 <img src="/images/salesforce/Experts/aparna_vedpathak.png" alt="Expert" className="saleForce_expert" />                                
//                 <img src="/images/salesforce/Experts/amit_cy_sharma.png" alt="Expert" className="saleForce_expert" />                
//                 <img src="/images/salesforce/Experts/manish_bv_sharma.png" alt="Expert" className="saleForce_expert" />                                
//             </div>

//         </>        
//     );
// };

// export default Experts

import React from "react";
import "./Experts.css";
import expertData from "../data/salesforceExperts.json";

const Experts = () => {
  const renderSection = (list = []) =>
    list.map((expert, index) => (
      <div key={index} className="profile-wrapper">
        <div className="profile-card">
          <div className="header-shape">
            <img
              src={`/images/salesforce/Experts/${expert.EID}.png`}
              alt={expert.name}
              className="profile-img"
            />
            <div className="translateup">
              <h2 className="name">{expert.name}</h2>
              <p className="email">{`${expert.EID}@accenture.com`}</p>
              <p className="title">{expert.role}</p>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    <>
      <div className="oracle-expert-banner">
        <img
          src={process.env.PUBLIC_URL + "/images/salesforce/Expertbanner.png"}
          alt="Expert Banner"
        />
      </div>

      <div className="oracle-expert-content">
        <p>
          Meet the minds behind ATCI’s intensive, innovative, fit-for-market
          Salesforce learning programs, enabling Accenture to lead in the
          marketplace and deliver on the promise of client excellence.
        </p>
      </div>

      <div className="experts_container">
        <div className="topRowContent">
          {renderSection(expertData?.Leadership)}
        </div>

        <div className="leadsRowContent">
          {renderSection(expertData?.Lead)}
        </div>

        <div className="leadsRowContent">
          {renderSection(expertData?.SME)}
        </div>
      </div>
    </>
  );
};

export default Experts;